var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { selectAllNurseryRecipesByLevel, } from "../balancingSelectors/selectBalancingUiDefinitions";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { selectOutskirtBuildingInfo, selectOutskirtBuildingLevel, } from "./selectOutskirtBuildingInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
import { mapRecipeIdToRecipeData } from "./selectRecipeInfo";
export var selectNurseryInfo = function (state) {
    return selectOutskirtBuildingInfo(state, IdOutskirtBuildings.Nursery);
};
export var selectIsQualifiedForNursery = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.Nursery);
};
export var selectNurseryRecipes = function (state) {
    var nurseryLevel = selectOutskirtBuildingLevel(state, IdOutskirtBuildings.Nursery);
    var allRecipes = selectAllNurseryRecipesByLevel(nurseryLevel);
    return allRecipes.map(function (element) {
        return selectNurseryRecipeDataFromRecipeWithUnlockLevel(state, element);
    });
};
var selectNurseryRecipeDataFromRecipeWithUnlockLevel = function (state, element) {
    var recipeData = mapRecipeIdToRecipeData(state, element.recipeId);
    return __assign({}, recipeData, { isUnlocked: element.isUnlocked, requiredNurseryLevel: element.requiredLevel });
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectNurseryInfo.ts
// module id = 862
// module chunks = 3